<template>
    <div>
        <div class="banner posr">
            <div class="mainbanner">
                <h2>
                    跟Bella儂儂分享你的喜悅
                    <br>
                    點選下方禮物，天天有機會把超值驚喜帶回家
                </h2>
            </div>
            <canvas-snow snowId="snow_in" />
            <div class="flipClockBox posa">
                <flip-clock 
                :digit="howLonger"
                :options="{
                    countdown: true,
                    clockFace: 'DailyCounter',
                }" />
            </div>
        </div>
        <div class="goods">
            <div class="container posr">
                <!--v-if="swiperDom.length"-->
                <div class="conTF">
                    <div class="row">
                        <div class="col-12 col-sm-1 col-md-2">
                            <div class="santaImg posr">
                                <img :src="require(`@/assets/images/pic/santa.png`)">
                                <div class="activity posa">
                                    <a href="javascript:;" class="hoverFill" v-b-modal.activity_modal>活動辦法</a>
                                    <a href="javascript:;" class="hoverFill" v-b-modal.winning_modal>得獎名單</a>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-10">
                            <div class="collection">
                                <swiper :options="swiperOption" ref="mySwiper">
                                    <swiper-slide v-for="(item, index) in swiperDom" v-bind:key="index">
                                        <div class="item posr">
                                            <!-- @click="openBox(index)" -->
                                            <div class="changeBox posr" ref="myop">
                                                <a :href="item.link" target="_blank">
                                                    <div class="img_box">
                                                        <img :src="require(`@/assets/images/pic/${item.pic}.png`)">
                                                    </div>
                                                </a>
                                                <div class="dateText posr">
                                                    【 Day {{ index + 1 }} 】
                                                </div>
                                                <!-- <div class="closeBox">
                                                    【 12 / {{ index + 5 }} 】
                                                </div> -->
                                            </div>
                                        </div>
                                    </swiper-slide>
                                    <div class="swiper-button-prev" slot="button-prev" @click="slideChange(1)"></div>
                                    <div class="swiper-button-next" slot="button-next" @click="slideChange(2)"></div>
                                    <div class="swiper-pagination" slot="pagination"></div>
                                </swiper>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import { FlipClock } from '@mvpleung/flipclock'
    import {
        FlipClock
    } from '../plugins/@mvpleung/flipclock/index'
    import CanvasSnow from '@/components/partial/CanvasSnow'
    import {
        swiper,
        swiperSlide
    } from 'vue-awesome-swiper'
    import {
        TweenMax
    } from 'gsap/TweenMax'

    export default {
        name: 'Home',
        data() {
            return {
                swiperOption: {
                    initialSlide: 0,
                    slidesPerView: 3,
                    spaceBetween: 30,
                    slidesPerGroup: 3,
                    loop: false,
                    simulateTouch: false,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    breakpoints: {
                        1920: {
                            spaceBetween: 0
                        },
                        767: {
                            slidesPerView: 1,
                            slidesPerGroup: 1,
                            spaceBetween: 10,
                        }
                    }
                },
                swiperDom: [{
                    pic: 'gift1',
                    link: 'https://www.bella.tw/articles/gift/17912',
                }, {
                    pic: 'gift2',
                    link: 'https://www.bella.tw/articles/gift/17877',
                }, {
                    pic: 'gift3',
                    link: 'https://www.bella.tw/articles/gift/17884',
                }, {
                    pic: 'gift4',
                    link: 'https://www.bella.tw/articles/gift/17883',
                }, {
                    pic: 'gift5',
                    link: 'https://www.bella.tw/articles/gift/17969',
                }, {
                    pic: 'gift6',
                    link: 'https://www.bella.tw/articles/gift/17965',
                }, {
                    pic: 'gift7',
                    link: 'https://www.bella.tw/articles/gift/17981',
                }, {
                    pic: 'gift8',
                    link: 'https://www.bella.tw/articles/gift/17881',
                }, {
                    pic: 'gift9',
                    link: 'https://www.bella.tw/articles/gift/17900',
                }, {
                    pic: 'gift10',
                    link: 'https://www.bella.tw/articles/gift/17852',
                }, {
                    pic: 'gift11',
                    link: 'https://www.bella.tw/articles/gift/18037',
                }, {
                    pic: 'gift12',
                    link: 'https://www.bella.tw/articles/gift/18066',
                }, {
                    pic: 'gift13',
                    link: 'https://www.bella.tw/articles/gift/17879',
                }, {
                    pic: 'gift14',
                    link: 'https://www.bella.tw/articles/gift/17893',
                }, {
                    pic: 'gift15',
                    link: 'https://www.bella.tw/articles/gift/17925',
                }, {
                    pic: 'gift16',
                    link: 'https://www.bella.tw/articles/makeup/18077',
                }, {
                    pic: 'gift17',
                    link: 'https://www.bella.tw/articles/gift/17880',
                }, {
                    pic: 'gift18',
                    link: 'https://www.bella.tw/articles/gift/18128',
                }, {
                    pic: 'gift19',
                    link: 'https://www.bella.tw/articles/gift/18132',
                }, {
                    pic: 'gift20',
                    link: 'https://www.bella.tw/articles/gift/17861',
                }, {
                    pic: 'gift21',
                    link: 'https://www.bella.tw/articles/skincare/17904',
                }, ],
            }
        },
        created() {
            this.swiperSlideDate()
        },
        mounted() {
            this.$nextTick(() => {
                this.openBox()
            })
        },
        components: {
            FlipClock,
            CanvasSnow,
            swiper,
            swiperSlide,
        },
        computed: {
            // 還要多久時間到12/25號
            howLonger() {
                let dt = new Date(),
                    nowYear = dt.getFullYear(),
                    nowMonth = dt.getMonth() + 1,
                    nowMonthAllDay = new Date(nowYear, nowMonth, 0).getDate(),
                    nowDay = dt.getDate(),
                    oneDayTime = 60 * 60 * 24,
                    nowTime = Math.floor((new Date(nowYear, 12, 25) - dt) / 1000), // 開始日期在這
                    sec = nowTime - (nowMonthAllDay * oneDayTime)
                if (nowYear != 2018 || nowMonth != 12 || nowDay < 2 || nowDay > 25) sec = 0 // 要改回來啊ＤＡＮ
                // if (nowMonth == 12 && nowDay > 25) sec = 0
                // console.log(dt ,nowYear, nowMonth, nowMonthAllDay, nowDay, sec)
                return sec
            },
            swiper() {
                return this.$refs.mySwiper.swiper;
            },
        },
        methods: {
            // 一進來判斷目前日期更新輪播物品
            swiperSlideDate() {
                let dt = new Date(),
                    nowYear = dt.getFullYear(),
                    nowMonth = dt.getMonth() + 1,
                    nowDay = dt.getDate(),
                    domW = document.documentElement.clientWidth,
                    slideDate;
                if (nowYear == 2018 && nowMonth == 12 && nowDay > 4 || nowDay < 26) {
                    if (domW > 768) {
                        /*  
                            0 == page 1 == 12/5,12/6,12/7
                            3 == page 2 == 12/8,12/9,12/10
                            6 == page 3 == 12/11,12/12,12/13
                            9 == page 4 == 12/14,12/15,12/16
                            12 == page 5 == 12/17,12/18,12/19
                            15 == page 6 == 12/20,12/21,12/22
                            18 == page 7 == 12/23,12/24,12/25
                        */
                        if (nowDay > 0) slideDate = 0
                        if (nowDay > 7) slideDate = 3
                        if (nowDay > 10) slideDate = 6
                        if (nowDay > 13) slideDate = 9
                        if (nowDay > 16) slideDate = 12
                        if (nowDay > 19) slideDate = 15
                        if (nowDay > 22) slideDate = 18
                        // console.log(nowDay, slideDate)
                    } else {
                        for (let i = 5; i < 26; i++) {
                            let N = 5
                            if (nowDay == i) {
                                slideDate = nowDay - N;
                            }
                        }
                    }
                } else {
                    slideDate = 0
                    // console.log(domW)
                    // console.log(this.swiperDom.length, nowDay, slideDate)
                }
                this.swiperOption.initialSlide = slideDate
            },
            // 打開盒子
            openBox(i) {
                let dt = new Date(),
                    nowDay = dt.getDate()
                console.log(nowDay)
                // 判斷api是否有記錄就增加
                if (i == undefined && nowDay >= 5) {
                    for (let i = 0; i < nowDay - 4; i++) {
                        // const element = this.swiperDom[i];
                        this.swiperDom[i].pic = `gift${i + 1}` // 換上api給的圖片
                        this.$refs.myop[i].classList.add('open')
                    }
                }

                // let date = i + 5; // 幾號開始可以點
                // if (date == nowDay) {
                //     // console.log(date, nowDay, i)
                //     this.swiperDom[i].pic = `gift${i + 1}` // 換上api給的圖片
                //     console.log(this.$refs.myop[0])
                //     this.$refs.myop[i].classList.add('open')
                // }
            },
            // 方向特效
            /* eslint-disable */
            slideChange(num) {
                let $prev = this.swiper.navigation.$prevEl,
                    $next = this.swiper.navigation.$nextEl,
                    duration = 0.3,
                    delay = 0.08,
                    nowTarget,
                    nowTargetDom;
                num == 1 ? nowTarget = $prev : nowTarget = $next
                nowTargetDom = nowTarget[0]
                if (nowTargetDom.classList.contains('swiper-button-disabled')) return false
                TweenMax.to(nowTarget, duration, {
                    scaleY: 1.6,
                    ease: Expo.easeOut
                });
                TweenMax.to(nowTarget, duration, {
                    scaleX: 1.2,
                    scaleY: 1,
                    ease: Back.easeOut,
                    easeParams: [3],
                    delay: delay
                });
                TweenMax.to(nowTarget, duration * 1.25, {
                    scaleX: 1,
                    scaleY: 1,
                    ease: Back.easeOut,
                    easeParams: [6],
                    delay: delay * 3
                });
                // nowTargetDom.classList.add('tsBoxShadow')
                // nowTargetDom.addEventListener("transitionend", ()=> {
                //     nowTargetDom.classList.remove('tsBoxShadow')
                // }, false);
            },
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /*.goods .swiper-wrapper .swiper-slide .item .img_box:after {
        content: "";
        background: rgba(211, 24, 34, 0.7);
        width: 100%;
        height: 73%;
        position: absolute;
        z-index: 9998;
        top: 0;
        left: 0;
        opacity: 1;
        top: 14%;
        padding-top: 100px;
    }*/

    .goods .swiper-wrapper .swiper-slide .item .img_box:before {
        content: "聖誕好禮 已開獎";
        white-space: pre-line;
        color: #fff;
        top: 50%;
        left: 50%;
        position: absolute;
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        z-index: 9999;
        font-size: 1rem;
        opacity: 1;
        text-align: center;
        height: 100%;
        width: 100%;
    }
</style>



